import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, arraysAreEqual, handleDateChange } from "../CommonComponents/CustomHooks";
import { AutoCompleteBox, DateBox, FormButton, InputBox, base64ToBlob } from "../CommonComponents/InputBox";
import { OperationalTable } from "../CommonComponents/OperationalTable";

const ManifestEntry = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [scanNo, setScanNo] = useState('')
    const [CheckAll, setCheckAll] = useState(false)
    const [tableData, setTableData] = useState([])
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [invoicePrint, setInvoicePrint] = useState(false)
    const [mainfestPrint, setmainfestPrint] = useState('')
    const inputrefs = useRef([]);
    const selectedDate2 = new Date();
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const [formData, setFormData] = useState({
        manifestNo: "",
        awbNo: "",
        vendor: "",
        toBranch: "",
        serviceType: "",
        manifestDate: formattedDate1,
        forwardingNo: "",
        awbNoList: [],
        pcs: "",
        weight: "",
        remarks: "",
    });

    const handleClear = () => {
        setFormData({
            manifestNo: "",
            awbNo: "",
            vendor: "",
            toBranch: "",
            serviceType: "",
            manifestDate: formattedDate1,
            forwardingNo: "",
            awbNoList: [],
            pcs: "",
            weight: "",
            remarks: "",
        });
        inputrefs.current['txtManifestDate'].focus();
        getManifestAwbNoDetail();
    }
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/SaveManifestEntry', { ...formData, awbNo: (formData.awbNoList).toString() })
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
            if (data.status === 'SUCCESS') {
                await setmainfestPrint(data.manifestNo)
                await setInvoicePrint(true)
            }
        }
    }

    const getManifestAwbNoDetail = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Operation/GetManifestAwbNoDetail', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }
    const handlePrint = async (value) => {
        await dispatch(setSubLoading(true))
        let imgresult = await ApiCall('/api/Report/ManifestPrint', { ManifestNo: mainfestPrint });
        await dispatch(setSubLoading(false))
        let result = imgresult;
        if (result.status === 'ERROR' || result.status === 'EXPIRED') {
            await NotificationSound(result.status, result.message, result.focus, inputrefs, handleClear);
            await dispatch(setSubLoading(false))
        }
        const blob = base64ToBlob(result.documentPdfBase64?.split(',')[1], 'application/pdf');
        const url = URL.createObjectURL(blob);
        const PDFWindow = window.open("");
        PDFWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");

    }

    const handleCheck = (id, awbNo) => {
        const updatedAwbNoList = [...formData.awbNoList];
        const index = updatedAwbNoList.indexOf(awbNo);

        if (index !== -1) {
            updatedAwbNoList.splice(index, 1);
        } else {
            updatedAwbNoList.push(awbNo);
        }
        setFormData({ ...formData, awbNoList: updatedAwbNoList });
    };

    const handleCheckAll = (value) => {
        setCheckAll(value);
        const updatedTableData = tableData?.Data.map(item => {
            return {
                ...item,
                checkStatus: value
            };
        });
        setTableData(prevCNResult => ({
            ...prevCNResult,
            Data: updatedTableData
        }));
        const updatedAwbNoList = value ? tableData?.Data.map(item => item.AwbNo) : [];
        let updatedPcs = value ? tableData?.Data.map(item => item.PCS) : [];
        updatedPcs = updatedPcs?.reduce((total, currentValue) => total + Number(currentValue), 0);
        let updatedActWgt = value ? tableData?.Data.map(item => item.Weight) : [];
        updatedActWgt = updatedActWgt?.reduce((total, currentValue) => total + Number(currentValue), 0);
        setFormData({
            ...formData, awbNoList: updatedAwbNoList,
            pcs: updatedPcs ? updatedPcs.toString() : '',
            weight: updatedActWgt ? updatedActWgt.toString() : ''
        });
    };

    const HandleScanData = async () => {
        if (!scanNo) {
            await NotificationSound('ERROR', 'Please enter Awb No.!', 'txtAwbNo', inputrefs);
            return;
        } else {
            let isAvaialble = tableData?.Data?.filter(item => item.AwbNo === scanNo).length;
            if (isAvaialble) {
                let tableData1 = tableData.Data.map(item => {
                    if (scanNo === item.AwbNo && item.checkStatus === false) {
                        return {
                            ...item,
                            checkStatus: true
                        }
                    } else {
                        return {
                            ...item,
                            checkStatus: item.checkStatus ? item.checkStatus : false
                        }
                    }
                })
                setScanNo('')
                const updatedList = tableData1?.filter(item => item.checkStatus).map(item => item.AwbNo) || [];
                setFormData({ ...formData, awbNoList: [...updatedList] })
            } else {
                setScanNo('')
                await NotificationSound('ERROR', 'AwbNo Not Found!', 'txtAwbNo', inputrefs);
                return;
            }
        }
    }

    useEffect(() => {
        let newTableData = tableData?.Data?.map(item => {
            const checkStatus = formData?.awbNoList?.some(awb => item.AwbNo === awb) ? true : false;
            return { ...item, checkStatus };
        });
        let newCheckedData = newTableData?.filter(item => item.checkStatus)
        let updatedPcs = newCheckedData?.map(item => item.PCS)
        updatedPcs = updatedPcs?.reduce((total, currentValue) => total + Number(currentValue), 0);
        let updatedActWgt = newCheckedData?.map(item => item.Weight)
        updatedActWgt = updatedActWgt?.reduce((total, currentValue) => total + Number(currentValue), 0);
        setFormData({
            ...formData,
            pcs: updatedPcs ? updatedPcs.toString() : '',
            weight: updatedActWgt ? updatedActWgt.toString() : ''
        });

        if (!arraysAreEqual(newTableData, tableData.Data)) {
            setTableData(CNResult => ({
                ...tableData, Data: newTableData,
                HideColumns: CNResult?.HideColumns ? [...CNResult?.HideColumns, 'checkStatus'] : ['checkStatus']
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData.Data, formData.awbNoList]);

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };
    const handleChange1 = (event, value) => {
        getManifestAwbNoDetail(value);
    };

    useEffect(() => {
        getManifestAwbNoDetail()
    }, [sortConfig])

    useEffect(() => {
        
        document.title = 'Manifest Entry / Bagging';
        inputrefs.current['txtManifestDate'].focus();
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <span className="fs-6 fw-bold headingspan"> {FindTranslatedKey('Manifest Entry / Bagging')}</span>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <InputBox
                            label='Manifest Number'
                            PlaceHolderText='System Generated'
                            inputrefs={inputrefs}
                            id='txtManifestNo'
                            value={formData.manifestNo}
                            disabled={true}
                        />

                        <DateBox
                            inputrefs={inputrefs}
                            label="Manifest Date"
                            placeholder="Manifest Date"
                            id='txtManifestDate'
                           // value={formData.manifestDate ? formData.manifestDate : ''}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtToBranch'].focus()
                                };
                            }}
                            required={true}
                            selected={formData.manifestDate === '' ? '' : new Date(formData.manifestDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'manifestDate')}
                        />

                        {/*<AutoCompleteBox*/}
                        {/*    label='Vendor'*/}
                        {/*    placeholder='Vendor'*/}
                        {/*    inputrefs={inputrefs}*/}
                        {/*    id='txtVender'*/}
                        {/*    value={formData.vendor}*/}
                        {/*    onKeyDown={(e) => {*/}
                        {/*        if (e.key === 'Enter') { inputrefs.current['txtToBranch'].focus() };*/}
                        {/*    }}*/}
                        {/*    inputValue={formData.vendor ? formData.vendor : ''}*/}
                        {/*    onInputChange={*/}
                        {/*        (event, newInputValue) => {*/}
                        {/*            handleAutoCompleteChange(event, newInputValue, '', 'GetVendor');*/}
                        {/*            setFormData({ ...formData, vendor: newInputValue })*/}
                        {/*        }}*/}
                        {/*    maxLength='50'*/}
                        {/*    options={autoCompleteOptions}*/}
                        {/*    setOptions={setAutoCompleteOptions}*/}
                        {/*    required={true}*/}
                        {/*/>*/}
                        <AutoCompleteBox
                            label='To Branch'
                            placeholder='To Branch'
                            inputrefs={inputrefs}
                            id='txtToBranch'
                            value={formData.toBranch}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtRemarks'].focus() };
                            }}
                            inputValue={formData.toBranch ? formData.toBranch : ''}
                            onInputChange={
                                (event, newInputValue) => {
                                    handleAutoCompleteChange(event, newInputValue, '', 'GetMBranch');
                                    setFormData({ ...formData, toBranch: newInputValue })
                                }}
                            maxLength='50'
                            options={autoCompleteOptions}
                            setOptions={setAutoCompleteOptions}
                            required={true}
                        />

                        {/*<InputBox*/}
                        {/*    label='Service Type'*/}
                        {/*    placeholder='Service Type'*/}
                        {/*    inputrefs={inputrefs}*/}
                        {/*    id='txtServiceType'*/}
                        {/*    value={formData.serviceType}*/}
                        {/*    onKeyDown={(e) => {*/}
                        {/*        if (e.key === 'Enter') { inputrefs.current['txtForwardingNo'].focus() };*/}
                        {/*    }}*/}
                        {/*    onChange={(e) => setFormData({ ...formData, serviceType: e.target.value })}*/}
                        {/*    maxLength='50'*/}
                        {/*/>*/}

                        {/*<InputBox*/}
                        {/*    label='Forwarding No'*/}
                        {/*    placeholder='Forwarding No'*/}
                        {/*    inputrefs={inputrefs}*/}
                        {/*    id='txtForwardingNo'*/}
                        {/*    value={formData.forwardingNo}*/}
                        {/*    onKeyDown={(e) => {*/}
                        {/*        if (e.key === 'Enter') { inputrefs.current['txtRemarks'].focus() };*/}
                        {/*    }}*/}
                        {/*    onChange={(e) => setFormData({ ...formData, forwardingNo: e.target.value })}*/}
                        {/*    maxLength='50'*/}
                        {/*/>*/}
                        <InputBox
                            label='PCS'
                            PlaceHolderText='PCS'
                            inputrefs={inputrefs}
                            id='txtPCS'
                            value={formData.pcs}
                            maxLength='25'
                            disabled={true}
                        />
                        <InputBox
                            label='Weight'
                            PlaceHolderText='Weight'
                            inputrefs={inputrefs}
                            id='txtWeight'
                            value={formData.weight}
                            disabled={true}
                            maxLength='25'
                        />
                        <InputBox
                            label='Remarks'
                            PlaceHolderText='Remarks'
                            inputrefs={inputrefs}
                            id='txtRemarks'
                            value={formData.remarks}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['btnSub'].focus() };
                            }}
                            onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
                            maxLength='250'
                        />

                    </div>

                </div>
                <div className='card-body'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        Export={false}
                        handleSubmit={handleSubmit}
                        handleClear={handleClear}
                        Print={invoicePrint}
                        handlePrint={handlePrint}
                    />
                </div>
            </div>

            <OperationalTable
                PageName={'ManifestEntry'}
                inputPlaceHolder='Awb No'
                showCheckBox={true}
                Filter={false}
                loading={isLoading}
                handleCheck={handleCheck}
                handleCheckAll={handleCheckAll}
                CheckAll={CheckAll}
                tableData={tableData}
                currentPageNo={currentPageNo}
                cnNo={scanNo}
                setcnNo={setScanNo}
                handleChange1={handleChange1}
                HandleScanList={HandleScanData}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}

export default ManifestEntry;